import { IProgramItemQuery } from '../interfaces/program-item.query.interface';
import { CourseOffering } from 'app/library/course-offering/models/course-offering.model';
import { RelevantExecution } from './relevant-execution.model';
import { ModuleUserProgressStatus } from 'app/library/module-user/enums/module-user-progress-status.enum';
import { FinalGrade } from 'app/library/final-grade/models/final-grade.model';
import { ModuleUserProgress } from 'app/library/module-user/models/module-user-progress.model';
import { ModuleUserAttendance } from 'app/library/module-user/models/module-user-attendance.model';
import { RelevantExecutionRuleEnum } from 'app/library/relevant-execution/enums/relevant-execution-rule.enum';

// @dynamic
export class ProgramItem {
    id: string;
    sort: number;
    courseOffering: CourseOffering;
    courseExecutions: number;
    relevantExecutions: RelevantExecution[];
    courseProgressStatus: ModuleUserProgressStatus;
    programFinalGrade: { executionId: string; finalGrade: FinalGrade };
    executionGrades: { executionId: string; finalGrade: FinalGrade }[];
    progresses: { executionId: string; progress: ModuleUserProgress }[];
    attendance: ModuleUserAttendance;

    participantCount: number;
    participantCompletedCount: number;
    participantCompletedPercentage: number;
    participantPercentage: number;
    relevantExecutionCount: number;
    relevantExecutionRule: RelevantExecutionRuleEnum;
    bookingCount: number;

    averageGrade: number;
    averageAttendance: number;

    constructor(programItem: IProgramItemQuery) {
        if (programItem) {
            this.id = programItem.id.toString();
            this.sort = programItem.sort;
            this.courseOffering = new CourseOffering(programItem.course_offering);
            this.courseExecutions = programItem.course_executions;
            this.courseProgressStatus = programItem.course_progress_status;
            this.attendance = programItem.attendance ? new ModuleUserAttendance(programItem.attendance) : null;

            this.participantCount = programItem.participant_count;
            this.participantCompletedCount = programItem.participant_completed_count;
            this.participantCompletedPercentage = programItem.participant_completed_percentage;
            this.participantPercentage = programItem.participant_percentage;

            this.averageGrade = programItem.average_grade;
            this.averageAttendance = programItem.average_attendance;

            this.relevantExecutionCount = programItem.relevant_execution_count;
            this.relevantExecutionRule = programItem.relevant_execution_rule;
            this.bookingCount = programItem.booking_count;

            this.relevantExecutions = programItem.relevant_executions?.length
                ? programItem.relevant_executions.map((relevantEexecution) => new RelevantExecution(relevantEexecution))
                : [];

            this.executionGrades = programItem.execution_grades?.length
                ? programItem.execution_grades.map((exeuctionGrade) => {
                      return { executionId: exeuctionGrade.execution_id.toString(), finalGrade: new FinalGrade(exeuctionGrade.final_grade) };
                  })
                : [];

            if (programItem.progresses) {
                this.progresses = programItem.progresses?.length
                    ? programItem.progresses.map((progress) => {
                          return { executionId: progress.execution_id.toString(), progress: new ModuleUserProgress(progress.progress) };
                      })
                    : [];

                // Adds progress to relevant execution
                this.relevantExecutions.map((relevantExecution) => {
                    relevantExecution.progress = this.progresses.find((progress) => progress.executionId === relevantExecution.id).progress;
                });
            }

            if (programItem.execution_grades) {
                // Adds final grade to relevant execution
                this.relevantExecutions.map((relevantExecution) => {
                    relevantExecution.finalGrade = this.executionGrades.find((executionGrade) => executionGrade.executionId === relevantExecution.id).finalGrade;
                });

                // Finds program final grade
                this.programFinalGrade = this.executionGrades.find((executionGrade) => executionGrade.finalGrade.id === String(programItem.final_grade?.id));
            }
        }
    }
}
